import Config from '@/utils/config'
import Home from '@/views/home/routes'
import { createMemoryHistory, createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:locale(.{2}-.{2})?',
    children: [
      {
        path: '',
        children: Home,
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/common/Contact.vue'),
        meta: { header: { showBackButton: true } }
      },
      {
        path: 'content/:key',
        name: 'content',
        component: () => import('@/views/common/content/Content.vue'),
        meta: { header: { showBackButton: true } }
      },
      {
        path: 'investors',
        name: 'investors',
        component: () => import('@/views/common/Investors.vue'),
        meta: { header: { showBackButton: true } }
      },
      {
        path: ':pathMatch(.*)*',
        component: () => import('@/views/common/PageNotFound.vue'),
      },
    ],
  },
]

const base = Config.appBasePath
  ? `/${Config.appBasePath}/`
  : undefined

export function createAppRouter() {
  const router = createRouter({
    history: Config.ssr
      ? createMemoryHistory(base)
      : createWebHistory(base),
    routes,
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition
      }

      if (to.hash) {
        return { el: to.hash }
      }

      return { left: 0, top: 0 }
    },
  })

  router.afterEach((to) => {
    // Check if the Mautic tracking object is available globally
    if (!import.meta.env.SSR && window.mt) {
      window.mt('send', 'pageview', { url: to.fullPath, title: to.meta.title || document.title });
    }
  });

  return router
}
